function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "qa1ziqo73a"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.240469 0 0 0 0 0.248608 0 0 0 0 0.252406 0 0 0 1.000000 0"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  filter: "url(#qa1ziqo73a)",
  transform: "translate(-2212 -933) translate(1960.5 134) translate(0 24) translate(28.5 64) translate(0 699) translate(189)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#3D3F40",
  d: "M20.75 20.44c.415 0 .75.336.75.75s-.335.75-.75.75h-7.252c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h7.253zM16.118 3.654l1.723 1.339c.608.362 1.083 1.009 1.263 1.775.179.758.049 1.54-.368 2.2l-.016.023-.007.01c-.068.089-.362.46-1.847 2.321-.014.025-.03.048-.047.07-.025.033-.052.063-.081.09l-.32.402-.229.286-1.69 2.116-.34.425-5.01 6.269c-.458.572-1.146.905-1.885.914l-3.64.046h-.01c-.346 0-.648-.238-.73-.577l-.818-3.471c-.17-.72-.001-1.461.46-2.037l9.42-11.782.01-.013c1.034-1.235 2.902-1.417 4.162-.406zm-5.223 4.133l-7.198 9.005c-.171.214-.234.49-.171.755l.68 2.885 3.04-.038c.289-.003.556-.132.733-.352l3.234-4.048.417-.521.418-.523 3.108-3.891-4.26-3.272zm2.217-2.77l-1.28 1.598 4.261 3.271 1.41-1.768c.164-.266.228-.642.142-1.004-.088-.371-.32-.686-.652-.887-.071-.05-1.756-1.357-1.808-1.398-.634-.508-1.56-.42-2.073.188z",
  transform: "translate(34.495 12)"
})))))))));

var SvgIconlyLightOutlineEdit = function SvgIconlyLightOutlineEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconlyLightOutlineEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconly-light-outline-edit.5c872075.svg";
export { ForwardRef as ReactComponent };